import { dimensions } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function CompareSection() {
  return (
    <section id="compare" className="w-full border-b border-background-200 bg-background-100">
      <div className="w-full px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:gap-14">
          <div>
            <SectionHeading
              index="04"
              title="多维对比"
              desc="不只看单一指标。下面五个维度按参考权重排列，权重越高，对整体观感的影响越大，你可以按自己最在意的部分优先看。"
            />
            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center gap-2 text-sm font-medium text-foreground-900">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className="ri-scales-3-line text-base"></i>
                </span>
                怎么用这张对比表
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                先确认自己更在意哪两三个维度，再用排行榜里的条目逐一对照。
                如果两个平台水平接近，就看移动端适配与检索体验，它们最影响日常顺不顺手。
              </p>
            </div>
          </div>

          <div className="space-y-4">
            {dimensions.map((item, index) => (
              <div
                key={item.name}
                className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
              >
                <div className="flex items-center justify-between gap-4">
                  <div className="flex items-center gap-3">
                    <span className="flex h-7 w-7 items-center justify-center rounded-md bg-secondary-100 font-heading text-xs font-bold text-secondary-900">
                      {index + 1}
                    </span>
                    <h3 className="font-heading text-base font-semibold text-foreground-950">
                      {item.name}
                    </h3>
                  </div>
                  <span className="whitespace-nowrap rounded-full bg-primary-100 px-2.5 py-1 text-[11px] font-medium text-primary-800">
                    权重 {item.weight}%
                  </span>
                </div>
                <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">
                  {item.desc}
                </p>
                <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <div
                    className={`h-full rounded-full ${
                      index === 0
                        ? "bg-primary-500"
                        : index === 1
                          ? "bg-accent-500"
                          : "bg-secondary-500"
                    }`}
                    style={{ width: `${item.weight * 3}%` }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}